var React = require('react');

function LiiconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.228257 5.85461H4.08587V18H0.228257V5.85461ZM2.18289 0C0.862586 0 0 0.906852 0 2.09712C0 3.26292 0.837343 4.19613 2.1324 4.19613H2.157C3.50254 4.19613 4.34049 3.26287 4.34049 2.09712C4.31524 0.906852 3.50259 0 2.18289 0ZM13.5574 5.5693C11.5097 5.5693 10.5924 6.74765 10.0806 7.57401V5.85461H6.22183C6.27291 6.99399 6.22183 18 6.22183 18H10.0806V11.2172C10.0806 10.8539 10.1058 10.4919 10.2074 10.2317C10.4868 9.50649 11.1216 8.7555 12.1866 8.7555C13.5838 8.7555 14.1418 9.86977 14.1418 11.5017V18H18V11.0356C18 7.30507 16.0971 5.5693 13.5574 5.5693Z"}));
}

LiiconInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = LiiconInline;

LiiconInline.default = LiiconInline;
